import { Route } from '@angular/router';
import { AuthGuard } from './core/auth/guards/auth.guard';
import { NoAuthGuard } from './core/auth/guards/noAuth.guard';
import { SignOutResolver } from './core/auth/sign-out.resolver';
import { LayoutComponent } from './layout/layout.component';
import { SignInComponent } from './modules/auth/sign-in/sign-in.component';
import { InitialDataResolver } from './app.resolvers';
import { HomeComponent } from './modules/home/home.component';
import { PhotoboothComponent } from './modules/photobooth/photobooth.component';
import { LayoutsComponent } from './modules/admin/layouts/layouts.component';
import { DashboardComponent } from './modules/admin/dashboard/dashboard.component';
import { ProfileComponent } from './modules/admin/profile/profile.component';
import { UserComponent } from './modules/admin/user/user.component';
import { TenantComponent } from './modules/admin/tenant/tenant.component';
import { RoleComponent } from './modules/admin/role/role.component';
import { PermissionComponent } from './modules/admin/permission/permission.component';
import { ProductComponent } from './modules/admin/product/product.component';
import { CategoryComponent } from './modules/admin/category/category.component';
import { OrderComponent } from './modules/admin/order/order.component';
import { PaymentGatewayComponent } from './modules/admin/payment-gateway/payment-gateway.component';
import { PaymentBankComponent } from './modules/admin/payment-bank/payment-bank.component';
import { PaymentChannelComponent } from './modules/admin/payment-channel/payment-channel.component';
import { PaymentMethodComponent } from './modules/admin/payment-method/payment-method.component';
import { VideoboothComponent } from './modules/videobooth/videobooth.component';
import { DigitalInvitationComponent } from './modules/digital-invitation/digital-invitation.component';
import { PackageComponent } from './modules/package/package.component';
import { LinkSegmentPhotoComponent } from './modules/link-segment-photo/link-segment-photo.component';
import { PartnershipComponent } from './modules/admin/partnership/partnership.component';
import { ProfessionalPhotographerComponent } from './modules/professional-photographer/professional-photographer.component';
import { SmartTicketingComponent } from './modules/smart-ticketing/smart-ticketing.component';
import { GuestBookComponent } from './modules/guest-book/guest-book.component';
import { CareerComponent } from './modules/career/career.component';
import { MitraComponent } from './modules/mitra/mitra.component';
import { EventOrganizerComponent } from './modules/event-organizer/event-organizer.component';
import { VoucherComponent } from './modules/voucher/voucher.component';
import { AboutUsComponent } from './modules/about-us/about-us.component';
import { ReviewComponent } from './modules/review/review.component';
import { PortfolioComponent } from './modules/portfolio/portfolio.component';

export const appRoutes: Route[] = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
    },

    {
        path: 'sign-in',
        component: SignInComponent,
        canActivate: [NoAuthGuard],
    },

    {
        path: 'sign-out',
        canActivate: [AuthGuard],
        resolve: { action: SignOutResolver },
        children: [],
    },

    {
        path: '',
        component: LayoutComponent,
        canActivate: [NoAuthGuard],
        children: [
            { path: '', component: HomeComponent },
            { path: 'package', component: PackageComponent },
            { path: 'voucher', component: VoucherComponent },
            { path: 'vouchers', component: VoucherComponent },
            { path: 'photobooth', component: PhotoboothComponent },
            { path: 'photobooth/:slug', component: PhotoboothComponent },
            { path: 'videobooth', component: VideoboothComponent },
            { path: 'professional-photographer', component: ProfessionalPhotographerComponent },
            { path: 'digital-invitation', component: DigitalInvitationComponent },
            { path: 'digital-invitation/:type', component: DigitalInvitationComponent },
            { path: 'digital-invitation/:type/:packageId', component: DigitalInvitationComponent },
            { path: 'digital-invitation/:type/:packageId/detail/:themeId', component: DigitalInvitationComponent },
            { path: 'digital-invitation/:type/:packageId/checkout/:themeId', component: DigitalInvitationComponent },
            { path: 'digital-invitation/:type/:packageId/payment/:themeId', component: DigitalInvitationComponent },
            { path: 'smart-ticketing', component: SmartTicketingComponent },
            { path: 'equipment-rental', loadComponent: () => import('./modules/Equipment Rental/equipment-rental.component').then(m => m.EquipmentRentalComponent) },
            { path: 'guest-book', component: GuestBookComponent },
            { path: 'guest-book/:package', component: GuestBookComponent },
            { path: 'career', component: CareerComponent },
            { path: 'career/:id', component: CareerComponent },
            { path: 'mitra', component: MitraComponent },
            { path: 'partnership', component: MitraComponent },
            { path: 'event-organizer', component: EventOrganizerComponent },
            { path: 'eo', component: EventOrganizerComponent },
            { path: 'about-us', component: AboutUsComponent },
            { path: 'review', component: ReviewComponent },
            { path: 'testimoni', component: ReviewComponent },
            { path: 'portfolio', component: PortfolioComponent },
            { path: 'portofolio', component: PortfolioComponent },
            { path: 'portfolio/:slug', component: PortfolioComponent },
            { path: 'portofolio/:slug', component: PortfolioComponent },
        ]
    },

    {
        path: 'momentmaker/seg/:encode',
        component: LinkSegmentPhotoComponent,
        canActivate: [NoAuthGuard],
    },

    {
        path: 'admin',
        component: LayoutsComponent,
        canActivate: [AuthGuard],
        children: [
            { path: 'dashboard', component: DashboardComponent },
            { path: 'profile', component: ProfileComponent },
            { path: 'user', component: UserComponent },
            { path: 'tenant', component: TenantComponent },
            { path: 'role', component: RoleComponent },
            { path: 'permission', component: PermissionComponent },
            { path: 'product', component: ProductComponent },
            { path: 'category', component: CategoryComponent },
            { path: 'order', component: OrderComponent },
            { path: 'payment-gateway', component: PaymentGatewayComponent },
            { path: 'payment-bank', component: PaymentBankComponent },
            { path: 'payment-channel', component: PaymentChannelComponent },
            { path: 'payment-method', component: PaymentMethodComponent },
            { path: 'partnership', component: PartnershipComponent },
        ]
    },

    // Fallback 404
    {
        path: '**',
        redirectTo: 'sign-in',
    },
];
